module.exports = __webpack_public_path__ + "static/media/SendingImageMessage14Sept2020.852a00c8.gif";